import React from 'react';
import { Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Track from './pages/Track';
import Login from './pages/Login';
import CustomerBook from './pages/CustomerBook';
import HubLayout from './pages/hub/HubLayout';
import Inbox from './pages/hub/Inbox';
import ScanIn from './pages/hub/ScanIn';
import Dispatch from './pages/hub/Dispatch';
import WalkInBooking from './pages/hub/WalkInBooking';
import CashDrawer from './pages/hub/CashDrawer';

const STAFF_ROLES = ['hub_officer','dispatcher','admin'];

function isStaff() {
  try {
    const u = JSON.parse(localStorage.getItem('sdx_user') || '{}');
    return STAFF_ROLES.includes(u.role);
  } catch { return false; }
}

function RequireStaff({ children }) {
  if (!isStaff()) return <Navigate to="/login" replace />;
  return children;
}

function TopNav() {
  return (
    <nav style={{ background: '#dc2626', color: '#fff', padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 20 }}>
      <Link to="/" style={{ color: '#fff', fontWeight: 800, fontSize: 18 }}>SIDAN Express</Link>
      <Link to="/track" style={{ color: '#fff' }}>Track</Link>
      <Link to="/book" style={{ color: '#fff' }}>Book Parcel</Link>
      <div style={{ marginLeft: 'auto' }}>
        {isStaff() ? <Link to="/hub/inbox" style={{ color: '#fff' }}>Hub Console</Link> : <Link to="/login" style={{ color: '#fff' }}>Login</Link>}
      </div>
    </nav>
  );
}

export default function App() {
  const location = useLocation();
  const hideTopNav = location.pathname.startsWith('/hub');

  return (
    <div>
      {!hideTopNav && <TopNav />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/track" element={<Track />} />
        <Route path="/track/:trackingNumber" element={<Track />} />
        <Route path="/login" element={<Login />} />
        <Route path="/book" element={<CustomerBook />} />

        {/* Hub console (staff only) */}
        <Route path="/hub" element={<RequireStaff><HubLayout /></RequireStaff>}>
          <Route index element={<Navigate to="inbox" replace />} />
          <Route path="inbox"    element={<Inbox />} />
          <Route path="scan-in"  element={<ScanIn />} />
          <Route path="dispatch" element={<Dispatch />} />
          <Route path="walk-in"  element={<WalkInBooking />} />
          <Route path="cash"     element={<CashDrawer />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
